import { TextFieldElement } from 'react-hook-form-mui';

import { buildHexMaskInput } from 'commonComponents/HexMaskInput';

const MAC_ADDRESS_REGEX = /^(([A-Fa-f0-9]{2}[:]){5}[A-Fa-f0-9]{2}[,]?)+$/i;
const InputMask = buildHexMaskInput('00:00:00:00:00:00');

type MacAddressProps = {
    index: number;
    disabled: boolean;
    required: boolean;
    defaultProps?: Record<string, unknown>;
};

export function MacAddress({ index, disabled, required, defaultProps }: MacAddressProps) {
    const fieldName = `mac_address_${index}`;

    return (
        <TextFieldElement
            data-testid="LicenseForm_MacAddress"
            InputProps={{ inputComponent: InputMask }}
            InputLabelProps={{ shrink: true }}
            label={`MAC address ${index + 1}`}
            name={fieldName}
            {...{ required, disabled }}
            rules={{
                pattern: { value: MAC_ADDRESS_REGEX, message: 'Invalid MAC Address' },
            }}
            {...defaultProps}
        />
    );
}
